import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router';
import idx from 'idx';
import PAPReview from 'pap/components/review';
import { fetchProject, fetchProjectIfNeeded } from 'project/ducks/project';
import { fetchCategoriesIfNeeded } from 'common/ducks/categories';
import { updateProjectRequest, fetchAttachments } from 'pap/ducks/project';
import { fetchPricing } from 'pap/ducks/pricing';
import { editReviewSection, getDetailsSteps, DETAILS_REVIEW_SECTIONS } from 'pap/ducks/workflow';
import { fetchCustomContracts } from 'common/ducks/contract';
import { get1to1CreativeFromProject, getSubCategoryFromProject, getCategoryFromProject, getVisibleBriefQuestions } from 'pap/utils';
import { advanceNegotiationRequest } from 'project/ducks/project_1_1';
import { setBannerError } from 'error';


PAPReview.need = [ fetchCategoriesIfNeeded ];


export function mapStateToProps(state, { params }) {
  const projectData = state.pap.project.projectData;
  const packages = state.pap.pricing.packages || [];
  const pack = packages.find((p) => p.id == (projectData || {}).original_package);
  const subCategory = getSubCategoryFromProject(projectData, state.categories);

  return {
    categories: state.categories,
    category: getCategoryFromProject(projectData, state.categories),
    packageName: pack? pack.name : '',
    workflow: state.pap.workflow,
    projectID: params.projectID,
    detailsSections: DETAILS_REVIEW_SECTIONS,
    detailsSteps: getDetailsSteps(state, params),
    briefQuestions: getVisibleBriefQuestions(projectData),
    briefAnswers: projectData ? projectData.brief_answers : {},
    projectData: projectData,
    attachments: state.pap.project.attachments,
    customContract: state.contract.customContracts.find((c) => c.type == 'ica'),
    awardValue1to1: projectData? projectData.one_to_one_negotiation_value : undefined,
    creative1to1: get1to1CreativeFromProject(projectData),
    user: state.user,
    subCategorySlug: idx(subCategory, _ => _.slug),
    subCategory
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchProject,
    fetchProjectIfNeeded,
    fetchCategoriesIfNeeded,
    fetchPricing,
    fetchCustomContracts,
    fetchAttachments,
    updateProjectRequest,
    setBannerError,
    advanceNegotiationRequest,
    editSection: editReviewSection,
  }, dispatch);
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PAPReview),
  { withRef: true }
);



// WEBPACK FOOTER //
// ./pap/containers/review.jsx